import axios from 'axios';

const postData = ({ email }) => {
  const POST_API =
    'https://yutcff4no1.execute-api.us-west-2.amazonaws.com/prod/submit';
  const config = { SHEET_ID: '1_bi9J4ZmBrCG4l_Uc0sEtcy8ttG5GPbo4El8yvmNmp0' };
  return axios.post(`${POST_API}?form=subscribe`, { email, ...config });
};

export default postData;
